import React, {useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import DownloadIcon from '@mui/icons-material/Download';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
import RotateLoader from 'react-spinners/RotateLoader';

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV

export default function ExcelUploadPopup(props) {
  const [open, setOpen] = React.useState(false);
  const uploadExcelFile = props.uploadExcelFile;
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [warning, setWarning] = useState(false);
  const [primerErrors, setPrimerErrors] = useState([]);
  const [sampleErrors, setSampleErrors] = useState([]);
  const formType = props.formType;
  const orderType = formType == 'sanger' ? "Sanger Sequencing" : "Fragment Analysis";

  const handleClickOpen = () => {
    setOpen(true);
    setError(false);
  };

  const handleClose = () => {
    setOpen(false);
    setWarning(false);
    setError(false);
    setSubmitted(false);
  };

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen}>
        Upload Excel
      </Button>
      <Dialog open={open} onClose={handleClose}>
        {!submitted ? 
                <MenuUpload
                uploadExcelFile={uploadExcelFile}
                handleClose={handleClose}
                setError={setError}
                setWarning={setWarning}
                setPrimerErrors={setPrimerErrors}
                setSampleErrors={setSampleErrors}
                setSubmitted={setSubmitted}
                orderType={orderType}
                formType={formType}
                />
        : <UploadResponse
        uploadExcelFile={uploadExcelFile}
        handleClose={handleClose}
        error={error}
        warning={warning}
        primerErrors={primerErrors}
        sampleErrors={sampleErrors}
        setWarning={setWarning}
        setError={setError}
        setSubmitted={setSubmitted}
        />
        }
      </Dialog>
    </div>
  );
}

const MenuUpload = (props) => {
  const uploadExcelFile = props.uploadExcelFile;
  const handleClose = props.handleClose;
  const setError = props.setError;
  const setWarning = props.setWarning;
  const setPrimerErrors = props.setPrimerErrors;
  const setSampleErrors = props.setSampleErrors;
  const setSubmitted = props.setSubmitted;
  const orderType = props.orderType;
  const formType = props.formType

  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setloading] = useState(false);

  async function handleSubmit() {
    setloading(true);
    try {
      const res = await uploadExcelFile(selectedFile);
      console.log(res)
      if (res.status === 200 && formType == 'sanger') {
        const sampleErrorLocation = res.data.samples.errorLocation;
        const primerErrorLocation = res.data.primers.errorLocation;
        console.log(sampleErrorLocation);
        console.log(primerErrorLocation);
        setPrimerErrors(primerErrorLocation);
        setSampleErrors(sampleErrorLocation);
        if (sampleErrorLocation.length > 0 || primerErrorLocation.length > 0) {
          setWarning(true);
        } else {
          // Do nothing
        }
        setSubmitted(true);
      } else if (res.status === 200) {
        //put the logic for the errors here for the samples
        const sampleErrorLocation = res.data.fragments.errorLocation;
        setSampleErrors(sampleErrorLocation);
        if (sampleErrorLocation.length > 0) {
          setWarning(true);
        } else {
          // Do nothing
        }
        setSubmitted(true);
      } else {
        setError(true);
        setSubmitted(true);
        console.log('ERROR EXCEL POPUP')
      }
    } catch (error) {
      // Handle any other errors
      setError(true);
      setSubmitted(true);
      // console.error(error);
    }
    setloading(false);
  }
  

  const changeHandler = (event) => {
    console.log('onchange');
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  async function DownloadFile(fileNo) {
    axios({
      url: API_ENDPOINT + '/upload/download',
      method: 'GET',
      responseType: 'blob', // important
      params: {
        fileType: fileNo,
      },
      onDownloadProgress: (progressEvent) => {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        ); // you can use this to show user percentage of file downloaded
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      var fileName;
      if (fileNo === 1) {
        fileName = 'Sanger-Sequencing-form.xlsx';
      } else {
        fileName = 'Fragment-Anlysis-form.xlsx';
      }
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    });
  }

  return (
    <>
      <DialogTitle>Upload Excel File for Bulk Data</DialogTitle>
        <Alert severity="info">We provide the option for you to upload an excel sheet which will parse the data on your behalf. 
        Please download the file below for your {orderType} order, and follow the insturctions labelled in the first sheet.</Alert>
        <DialogContent>
        <div style={{textAlign: 'center'}}>
        <Button variant="outlined"
        onClick={() => DownloadFile(formType == "sanger" ? 1 : 0)}
        endIcon={<DownloadIcon />}>{orderType} Excel File </Button>
        <br></br>
        <br></br>
        </div>
          <DialogContentText>
            Please only upload the excel file provided by the lab.
            <br></br>
            <br></br>
          </DialogContentText>
          <div style={{textAlign: 'center'}}>
          <input
            type="file"
            name="clientExcelUploadBody"
            onChange={changeHandler}
            disabled={loading}
            />
            </div>
        </DialogContent>
        <DialogActions style={{justifyContent: 'center'}}>
          <Button onClick={handleClose}>Cancel</Button>
                <LoadingButton
                size="large"
                classes="profileSubmit"
                type="submit"
                variant="outlined"
                onClick={handleSubmit}
                disabled={!isFilePicked}
                loading={loading}
                loadingIndicator={
                  <RotateLoader
                    cssOverride={{ left: '100%' }}
                    size={7}
                    margin={-15}
                  />
                }
                >
Upload
</LoadingButton>
        </DialogActions>
    </>
  )
}

const UploadResponse = (props) => {
  const error = props.error;
  const setError = props.setError;
  const warning = props.warning;
  const primerErrors = props.primerErrors;
  const sampleErrors = props.sampleErrors;
  const handleClose = props.handleClose;
  const setSubmitted = props.setSubmitted;


  return (
    <>
      <DialogTitle>Upload Excel File for Bulk Data</DialogTitle>
        {error ? (
          <div>
            <Alert severity="error">Error: Please upload again with lab's excel file, or contact adminsitrator if issue persists.</Alert>
          </div>
        ) : (
          <>
            {warning && (
              <>
              <Alert severity="warning">We've retained as much data as possible, however, we've found some errors, please review them below before uploading again
              or edit the form directly. Any remaining errors will be showcased on the online form.</Alert>
                {/* Warning message */}
                <DialogContent dividers style={{ overflowY: 'auto' }}>
                <ul>
                  {sampleErrors.map((well, index) => (
                    <li key={index}>
                      <strong>Well: {well.well}</strong>
                      <ul>
                        {well.msg.map((error, i) => (
                          <li key={i}>{error}</li>
                        ))}
                      </ul>
                    </li>
                  ))}
                  {primerErrors.map((primer, index) => (
                    <li key={index}>
                      <strong>Primer ID: {primer.id}</strong>
                      <ul>
                        <li>{primer.msg}</li>
                      </ul>
                    </li>
                  ))}
                </ul>
                </DialogContent>
              </>
            )}

            {!warning && !error && (
              <>
                <Alert severity="success">File uploaded and read sucessfully! No errors found. 
                <br></br>
                <strong>Please review the sample list for detailed errors.</strong></Alert>
              </>
            )}
          </>
        )}
      <DialogActions style={{justifyContent: 'center'}}>
      <Button variant="contained" color="primary" onClick={handleClose}>Return to form</Button>
        <Button variant="contained" color="primary" onClick={() => {
          setSubmitted(false)
          setError(false);
          }}>Try Again</Button>
      </DialogActions>
    </>
  );
}